import React, { HTMLAttributes } from "react";
import { observer } from "mobx-react-lite";
import cx from "classnames";
//import { Hooks } from "@xt/xtbase";
//const { useTranslation } = Hooks;
//import store from "store";
import styles from "./index.module.scss";
interface TitleProps extends HTMLAttributes<HTMLDivElement> {
  attr?: any;
  title?: string;
  children?: React.ReactNode;
}
const Title: React.FC<TitleProps> = ({ className, title, children }) => {
  //const t = useTranslation();
  //const {isLogin} = store.user;
  return (
    <div className={cx(styles["account-title"], className)}>
      <span>{title}</span>
      {children}
    </div>
  );
};
export default observer(Title);
